<template>
  <div class="web-media-title">
    <div class="media-title-box">
      <div class="web-media-title-line"></div>
      <div class="web-media-title-title">
        <div class="web-media-chinese">{{titleChinese}}</div>
        <div class="web-media-english">{{titleEnglish}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "cms-media-title",
    props: {
      titleChinese: {
        type: String,
        default: ""
      },
      titleEnglish: {
        type: String,
        default: ""
      }
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-media-title {
    padding: 39px 0 9px 0;
  }

  .media-title-box {
    height: 72px;
    padding-top: 32px;
    position: relative;
  }

  .web-media-title-line {
    width: 97%;
    height: 8px;
    border-top: 1px solid #999999;
    border-bottom: 1px solid #999999;
    margin: 0 auto;
  }

  .web-media-title-title {
    text-align: center;
    padding: 0 20px;
    background-color: #F8F8F8;
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .web-media-chinese {
    height: 45px;
    line-height: 45px;
    font-size: 30px;
    font-family: Source Han Sans CN Bold;
    color: #0861D1;
  }

  .web-media-english {
    font-size: 18px;
    color: #8D8A8E;
  }

  @media screen and (max-width: 800px) {
    .web-media-title {
      padding: 29px 0 9px 0;
    }

    .media-title-box {
      height: 48px;
      padding-top: 21px;
    }

    .web-media-title-line {
      height: 6px;
    }

    .web-media-title-title {
      padding: 0 20px;
    }

    .web-media-chinese {
      height: 30px;
      line-height: 30px;
      font-size: 20px;
    }

    .web-media-english {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mediaTitle.vue